import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { MessageScreen } from "../components";
import { MessageHeader } from "../components/chat";

export const Message = () => {
  return (
    <ContentLayout header={<MessageHeader />}>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER]}
          >
            <MessageScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
